module.exports = __webpack_public_path__ + "static/media/homepage-hero4.1d866410.png";